import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-media-xing",
  "use": "social-media-xing-usage",
  "viewBox": "0 0 52 49",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 49\" id=\"social-media-xing\"><g fill-rule=\"evenodd\"><ellipse class=\"bg\" cx=\"28.205\" cy=\"24.359\" rx=\"23.718\" ry=\"24.359\" /><path class=\"letter\" d=\"M22.783 7.692L11.658 27.178l7.167 12.566h7.49l-7.17-12.566L30.27 7.692h-7.488zM1.39 13.55l4.17 7.347L0 30.053h7.06l5.56-9.157-4.17-7.347H1.39z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol